export { default } from './GiftsSlider';
